import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

export const QuestionInputWrapper = styled.div`
  .selection-wrapper {
    gap: 0px;

    .mantine-Checkbox-body {
      width: 16px;
      height: 16px;
      cursor: pointer;

      .mantine-Checkbox-inner {
        width: 16px;
        height: 16px;
      }
    }
    input {
      font-size: 14px;
      width: 16px;
      height: 16px;
      border: 1px solid rgb(200, 200, 200) !important;
    }
  }
  .selection-wrapper > div label {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-direction: row;
  }
  .hasError {
    input,
    .mantine-Select-input,
    .mantine-DateInput-input,
    textarea {
      border: 1px solid ${theme.colours.error} !important;
    }
  }
`;
